<template>
  <BaseDataPlaceholder
    :src="src"
    :styleConfig="styleConfig"
  >
    <template v-slot:top>
      <slot name="top" />
    </template>
    <template v-slot:bottom>
      <slot name="bottom" />
    </template>
  </BaseDataPlaceholder>
</template>

<script>
  import BaseDataPlaceholder from '@base/v2/base-data-placeholder'
  import { FontStyle } from '@js/styles'
  import { IMAGE_FILES } from '@js/constants'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DataPlaceholderPrimary',
    inheritAttrs: false,
    components: {
      BaseDataPlaceholder,
    },
    data: function () {
      return {
        imageFile: IMAGE_FILES.PLACEHOLDER.PRIMARY,
        src: '',
        styleConfig: {
          bottomText: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
          },
          container: {},
          image: {
            display: 'block',
            height: '130px',
            width: '174px',
          },
          topText: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
          },
        },
      };
    },
    created: function () {
      this.src = require(`@img/${this.imageFile}`);

      Object.assign(
        this.styleConfig.bottomText,
        {
          color: this.color.dark2(),
        },
      );
      Object.assign(
        this.styleConfig.topText,
        {
          color: this.color.dark2(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
